import { useCreate, useDelete, useDetail, useList, useUpdate, usePartialUpdate } from "@inmagik/react-crud"
import { User } from "../types"
import { API_URL } from "../constants"

export function useUtentiList(params: Record<string, string> = {}) {
  return useList<User>(`${API_URL}/utenti`, {
    query: params,
  })
}

export function useUtente(id: number | undefined) {
  return useDetail<User>(`${API_URL}/utenti`, id?.toString())
}

export function useCreateUtente() {
  return useCreate<User>(`${API_URL}/utenti`)
}

export function useUpdateUtente() {
  return useUpdate<User>(`${API_URL}/utenti`)
}

export function useDeleteUtente() {
  return useDelete(`${API_URL}/utenti`)
}

export function usePartialUpdateUtente() {
  return usePartialUpdate<User>(`${API_URL}/utenti`)
}